import { render } from "./GameSetup.vue?vue&type=template&id=2dee04bf&scoped=true"
import script from "./GameSetup.vue?vue&type=script&lang=js"
export * from "./GameSetup.vue?vue&type=script&lang=js"

import "./GameSetup.vue?vue&type=style&index=0&id=2dee04bf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dee04bf"]])

export default __exports__